<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand to="/">
      <img
        class="c-sidebar-brand-full"
        size="custom-size"
        :src="LOGO_URI"
        :height="35"
      />
      <img
        class="c-sidebar-brand-minimized"
        size="custom-size"
        :src="LOGO_ICON_URI"
        :height="28"
      />
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="filteredNavItems"/> <!-- "$options.navItems" -->
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import navItems from './_nav'
const LOGO_FILE_PATH = require('@/assets/logo.png');
const LOGO_ICON_FILE_PATH = require('@/assets/logo_icon.png');
export default {
  name: 'TheSidebar',
  data() {
    return {
      LOGO_URI: LOGO_FILE_PATH,
      LOGO_ICON_URI: LOGO_ICON_FILE_PATH,
      role: localStorage.getItem('role'),
      filteredNavItems: [],
    }
  },
  created() {
    this.filteredNavItems = [
      {
        _name:"CSidebarNav",
        _children: filterNavItems(navItems[0]._children, this.role),
      },
    ]
  },
  mounted() {
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  }
}

function filterNavItems(navItems, role) {
    return navItems.map(item => {
      if (!item.roles || item.roles.includes(role)) {
        if (item._children) {
          return {
            ...item,
            _children: filterNavItems(item._children, role),
          };
        }
        if (item.items) {
          return {
            ...item,
            items: filterNavItems(item.items, role),
          };
        }
        return item;
      }
      return null;
    }).filter(item => item);
}

</script>
